import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { MainModalStyles } from './MainModalStyles';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { RALColors, countries, options } from '../../_data';
import { MyContentWindow, modeStateType } from '../../_types';
import * as formik from 'formik';
import * as yup from 'yup';

interface IMainModalProps {
  show: boolean;
  handleClose: () => void;
  state: modeStateType;
}

interface IFormikValues {
  name?: string;
  email?: string;
  phone?: string;
  message?: string;
  country?: string;
}

interface ModeStateStringType {
  model?: string;
  grassType?: string;
  grassColor?: string;
  frameColor?: string;
  illuminationPillars?: string;
  roofing?: string;
  benches?: string;
  doorType?: string;
  doorLocation?: string;
  protection?: string;
  interior?: string;
  personalizedCorners?: string;
  personalizedNet?: string;
  personalizedCornersImage?: string | File;
}

interface IAllAttributes extends IFormikValues, ModeStateStringType {
  screenShot?: File | null;
}

const MainModal = ({
  show = false,
  handleClose = () => {},
  state,
}: IMainModalProps) => {
  const [validated, setValidated] = useState<boolean>(false);
  const { Formik } = formik;
  const schema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().required('Email is required').email('Incorrect email'),
    phone: yup.string(),
    message: yup.string(),
    country: yup.string(),
  });

  const formikSubmit = (values: IFormikValues) => {
    document.querySelector('.loading__container')?.classList.add('loading');
    let allAttributes: IAllAttributes = {};
    const receivedState: ModeStateStringType = seekingStateNames(state);

    const iframe = document.querySelector('#main-frame') as HTMLIFrameElement;
    let convertedFile: File | null = null;
    if (iframe) {
      const windowFrame = iframe?.contentWindow as MyContentWindow;
      const procedures = windowFrame && windowFrame?.v3d?.puzzles?.procedures;
      if (procedures) {
        const base64String: string = procedures.takeScreenShot();
        const fileName: string = 'screen-shot.png';
        const fileType: string = 'image/png';
        convertedFile = base64ToFile(base64String, fileName, fileType);
        // downloadFile(convertedFile);
        // console.log(convertedFile);
      }
    }

    allAttributes = { ...values, ...receivedState, screenShot: convertedFile };
    // console.log(allAttributes);

    window.parent.postMessage({
      action: 'send_mail',
      data: allAttributes,
    });

    // handleClose();
  };

  const seekingStateNames = (states: modeStateType) => {
    let clonedStates: ModeStateStringType = {};
    for (const state in states) {
      const stateAs = state as keyof typeof states;
      const value = states[stateAs];
      if (stateAs.includes('Color')) {
        if (stateAs === 'frameColor') {
          let flag: boolean = false;
          RALColors.forEach((color) => {
            if (value === color.hexValue) {
              clonedStates[stateAs] = color.name;
              flag = true;
            }
          });
          if (!flag) {
            clonedStates[stateAs] = states[stateAs];
          }
        } else {
          clonedStates[stateAs] = states[stateAs] as string;
        }
      } else if (typeof states[stateAs] === 'boolean') {
        clonedStates[stateAs] = states[stateAs] ? 'Yes' : 'No';
      } else if (stateAs === 'protection') {
        clonedStates[stateAs] = states[stateAs].toString();
      } else {
        options.forEach((option) => {
          if (stateAs === option.value) {
            option.data.forEach((data) => {
              if (value === data.value) {
                clonedStates[stateAs] = data.name;
              }
            });
          }
        });
      }
    }
    clonedStates.personalizedCornersImage = states.personalizedCornersImage;
    if (!states.personalizedCorners) {
      clonedStates.personalizedCornersImage = '';
    } else if (states.personalizedCorners && states.personalizedCornersImage) {
      const uploadedFile = states.personalizedCornersImage as any;
      if (uploadedFile instanceof File) {
        const fileExtension = uploadedFile.type.split('/')[1];
        const newFile = new File(
          [uploadedFile],
          `personalized-corner.${fileExtension}`,
          {
            type: uploadedFile.type,
          }
        );
        clonedStates.personalizedCornersImage = newFile;
        // downloadFile(newFile);
        // console.log(newFile);
      }
    }
    return clonedStates;
  };

  // function downloadFile(file: File) {
  //   const downloadLink = document.createElement('a');
  //   downloadLink.href = URL.createObjectURL(file);
  //   downloadLink.download = file.name;
  //   downloadLink.style.display = 'none';
  //   document.body.appendChild(downloadLink);
  //   downloadLink.click();
  //   document.body.removeChild(downloadLink);
  // }

  function base64ToFile(
    base64String: string,
    fileName: string,
    fileType: string
  ): File {
    const base64Data = base64String.replace(/^data:[^;]+;base64,/, ''); // Remove data URL prefix
    const binaryData = atob(base64Data); // Decode the Base64 data

    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: fileType }); // Create Blob
    const file = new File([blob], fileName, { type: fileType }); // Create File

    return file;
  }

  return (
    <MainModalStyles show={show} onHide={handleClose}>
      {/* error | loading class*/}
      <div className={`loading__container`}>
        <div className="loader"></div>
        <a className="reload__button" href="/">
          An error happened!. Click to reload
        </a>
      </div>
      <Formik
        validationSchema={schema}
        onSubmit={formikSubmit}
        initialValues={{
          name: '',
          email: '',
          phone: '',
          message: '',
          country: 'United States',
          // name: 'Hieu Huynh',
          // email: 'huynhchihieu.bk@gmail.com',
          // phone: '0123123',
          // message: 'no comment',
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
        }) => (
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Customer Information</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="name">
                  <Form.Label>Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    autoComplete="off"
                    placeholder="name"
                    isInvalid={touched.email && !!errors.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="email">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    autoComplete="off"
                    value={values.email}
                    onChange={handleChange}
                    isInvalid={touched.email && !!errors.email}
                    type="email"
                    name="email"
                    placeholder="infor@gmail.com"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="phone">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder="0123456789"
                    value={values.phone}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="note">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    name="message"
                    value={values.message}
                    onChange={handleChange}
                    as="textarea"
                  />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="note">
                  <Form.Label>Country</Form.Label>
                  <Form.Select
                    name="country"
                    value={values.country}
                    onChange={handleChange}
                    aria-label="Default select example"
                  >
                    {countries.map((country) => {
                      return (
                        <option key={country.id} value={country.name}>
                          {country.name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <div className="submit__button__container">
                <button type="submit" className="submit__button">
                  Send Project
                </button>
              </div>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </MainModalStyles>
  );
};

export default MainModal;
